export default __webpack_public_path__ + "static/media/mobile-mockup.1e963f45.png";